import { useMutation } from '@tanstack/vue-query';

import mutationLogin from '../api/mutationLogin';
import {
  writeAccessToken,
  writeRefreshExpires,
  writeRefreshToken,
  writeToken,
} from '../core/helpers';

import type { UseMutationOptions } from '@tanstack/vue-query';

export default (
  options?: UseMutationOptions<
    AwaitedReturn<typeof mutationLogin>,
    any,
    Parameters<typeof mutationLogin>[0],
    unknown
  >
) => {
  return useMutation({
    ...options,
    mutationFn: mutationLogin,
    onSuccess(data, variables, ...rest) {
      // 後端給的時間格式在 Safari 不支援 `new Date(data.expAt)`
      writeToken(variables.code);
      writeAccessToken(data.accessToken);
      writeRefreshToken(data.refreshToken);
      writeRefreshExpires(new Date(data.expAt));
      options?.onSuccess?.(data, variables, ...rest);
    },
  });
};
